import React, { useState } from "react";

const LibraryBookDueDateCalculator = () => {
  const [dob, setDob] = useState("");
  const [age, setAge] = useState(null);

  const calculateAge = () => {
    const birthDate = new Date(dob);
    const today = new Date();
    const calculatedAge = today.getFullYear() - birthDate.getFullYear();
    setAge(calculatedAge);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Library Book Due Date Calculator</h2>
      <input type="date" className="border p-2 w-full mt-3" onChange={(e) => setDob(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateAge}>Calculate Age</button>
      {age && <div className="mt-3 text-center text-lg">Age: <span className="font-bold text-green-600">{age} years</span></div>}
    </div>
  );
};

export default LibraryBookDueDateCalculator;
